import React, { useEffect, useState } from "react";
import "./ThankYou.css";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">

        <div className="tick-circle">
          <span className="tick-mark">✔</span>
        </div>

        <h1 className="thankyou-title">Your Response Has Been Submitted.</h1>

        <p className="thankyou-subtext">
          A Confirmation Email Has Been Sent To Your Mail Id Shortly. Check It.
        </p>

        <p className="thankyou-note">
          Note: Please Check Spam/Junk Folder.
        </p>

        <p className="thankyou-team">
          Our Team Reach Out To You Shortly.
        </p>

        <p className="thankyou-signature">
          - Praveen Kumar With <span className="heart">❤️</span>
        </p>

        <p className="redirect-text">
          Redirecting to Home in <b>{countdown}</b> seconds...
        </p>

        <button className="thankyou-btn" onClick={() => navigate("/")}>
          Go Back Home
        </button>

      </div>
    </div>
  );
};

export default ThankYou;